<template>
  <TenderInfoPanel
    :mini.sync="mini"
    small
    :tender="tender"
    @update:tender="updateTender">
    <div
      key="tender-visits-panel-footer"
      slot="footer"
      class="width-100"
      style="border-top: 1px solid var(--main__green_locked);">
      <sButton
        class="bold"
        :class="mini ? 'mt-2 flex flex-center' : 'my-2'"
        data-qa="go-to-tenderitem"
        icon="long-arrow"
        icon-class="s-svg-icon-rotate-90"
        icon-size="11px"
        :rounded="false"
        :to="{name: 'tenderitem', params: { id: tender.tenderId, org: $route.params.org }}"
        type="text">
        <template v-if="!mini">
          {{ $t('Tenders.BackToTender') }}
        </template>
      </sButton>
    </div>
    <div class="tender-page-view-left">
      <div class="tender-page-view-header">
        <Breadcrumbs
          class="pa-0"
          :items="breadcrumbs"/>
        <TenderTopActions
          :tender="tender"/>
      </div>
      <div
        class="pt-2 width-100">
        <template v-if="loading">
          <v-skeleton-loader
            class="mt-10 pr-8"
            type="heading"
            width="100%"/>
          <v-skeleton-loader
            class="mt-3 pr-8"
            type="sentences"
            width="100%"/>
          <v-skeleton-loader
            class="mt-4 main__green mt-5"
            type="table-thead, table-tbody"
            width="100%"/>
        </template>
        <template v-else-if="tender">
          <div class="flex flex-between">
            <div
              class="h1-headline text-left pb-2">
              <TooltipedText
                data-qa="tender-title"
                :line-count="3"
                :value="tender ? tender.title : '–'"/>
            </div>
          </div>

          <div class="flex flex-between">
            <div
              class="text-start h8-text"
              data-qa="item-category">
              {{ tender && tender.category ? tender.category.code + ' ' + tender.category.title :'–' }}
            </div>
            <div class="btn-block">
              <TooltipedBtn
                data-qa="btn-export-to-excel"
                :disabled="loading || loadingToExcel || hideViewByParticipantsDuringBidReceptionOrAuction"
                icon="excel"
                :loading="loadingToExcel"
                :text="hideViewByParticipantsDuringBidReceptionOrAuction ? $t('Tenders.InfoShowAfterFinishBidding') : $t('Tenders.DownloadTendersToExcel')"
                @click="exportToExcel"/>
            </div>
          </div>
          <TenderVisitsTable
            :items="visits"
            :tender="tender"/>
        </template>
      </div>
    </div>
  </TenderInfoPanel>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import TenderVisitsTable from 'components/tenders/TenderVisitsTable.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'

import TenderInfoPanel from 'components/tenders/tender page/TenderInfoPanel.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import godModeMixin from 'mixins/godModeMixin'


import axios from 'axios'
import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

/**
 * Страница "Аналіз переглядів тендера"

 * @vue-data {Boolean} loading - загрузка данных
 * @vue-data {Boolean} loadingToExcel - загрузка данных в Excel
 * @vue-data {Array} breadcrumbs - Крошки
 * @vue-data {Array} visits - Данные посетителей тендера
 */
export default {
  name: 'TenderVisitsPanel',
  mixins: [ godModeMixin ],
  data() {
    return {
      mini: false,
      loading: true,
      loadingToExcel: false,
      tender: {},
      breadcrumbs: [],
      visits: [],
    }
  },
  methods: {
    updateTender(value) {
      this.$emit('update:tender', value)
    },
    async exportToExcel() {
      this.loadingToExcel = true
      const uri = `${window.config.GrapgQlUrl}/files/generateReport/visitors?tenderId=${this.tender.tenderId}`
      axios.post(uri, null,
        {
          headers: await files_api.getHeaders('application/json'),
          responseType: 'blob'
        }
      ).then((res) => {
        var blobUrl = URL.createObjectURL(res.data)
        let link = document.createElement('a')
        document.body.appendChild(link )
        link.style = 'display: none'
        link.href = blobUrl
        link.download = this.$t('Common.AnalysisOfTenderViews')
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
        }, 0)
      })
        .finally(() => {
          this.loadingToExcel = false
        })
    },
    /**
     * Инициализация данных страницы
     */
    async initData() {
      this.loading = true
      try {
        const tenderInfo = await this.$store.dispatch('getTenderItem', {id: Number(this.$route.params.id)})
        tenderInfo.publishedDate = this.$moment(tenderInfo.publishedDate).format('DD.MM.YYYY HH:mm')
        this.tender = tenderInfo
        await api.tenderVisits( Number(this.$route.params.id) )
          .then(res => {
            if (res?.length) {
              res.forEach(resItem => {
                resItem.lastViewDate = this.$moment(resItem.lastViewDate).format('DD.MM.YYYY HH:mm')
              })
              this.visits = res
            }
            return res
          })
      } catch (er) {
        this.$log_error(er)
      }
      this.loading = false
    },
  },
  computed: {
    hideViewByParticipantsDuringBidReceptionOrAuction() {
      if (![4, 7].includes(this.tender.tenderStatus.id)) {
        return false
      }
      if (this.mixin_isGodMode) {
        return false
      }
      return this.$can('is', 'hideViewByParticipantsDuringBidReceptionOrAuction')
    },
    can_change_winners() {
      let status = this.tender?.tenderStatus?.id
      return this.$can('change', 'tenderWinnerChangeMethodAccessibility')
        && (status == 10 || (status == 11 && !!this.tender.participantCount))
        && !this.tender?.biddingType?.isFrameFirstStage
    },
  },
  async created() {
    if (!this.mixin_accessToTenderView) {
      this.$router.push({name: '404'})
      return
    }
    await this.initData().then(() => {
      this.breadcrumbs = [
        {
          index: 0,
          text: this.$t('Tenders.Tenders'),
          maxLength: 100,
          to: { name: 'tenders', params: {org: this.$route.params.org}}
        },
        {
          index: 1,
          maxLength: 30,
          to: {name: 'tenderitem', params: {org: this.$route.params.org, id: this.tender?.tenderId}},
          text: (this.tender?.title || '')
        },
        {
          maxLength: 40,
          text: this.$t('Common.AnalysisOfTenderViews')
        },
      ]
    })
  },
  components: {
    Breadcrumbs,
    TooltipedBtn,
    TooltipedText,
    TenderInfoPanel,
    TenderVisitsTable,
  },
}
</script>
<style scoped lang="scss">
.tender-page-view {
  &-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background: var(--v-main__green-base);
    height: 44px;
    display: grid;
    padding: 0 !important;
    grid-template-columns: auto auto;
    border-bottom: 1px solid var(--main__green_locked);
    &::after {
      content: "";
      border-bottom: 1px solid var(--main__green_locked);
      position: absolute;
      right: -17px;
      bottom: -1px;
      width: 18px;
      height: 2px;
    }
  }
  &-left {
    max-width: 100vw;
    padding-left: 20px;
    padding-bottom: 16px;
    padding-right: 12px;
    position: relative;
  }
}

</style>
